import {
  httpStatusArr,
  messageTypeArr,
} from "../../../core/config/AppConstants";
import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./../../containers/Layout/Layout.css";
import {
  Button,
  Container,
  Content,
  Form,
  Input,
  Loader,
  Modal,
  Schema,
} from "rsuite";
import { StringType } from "schema-typed";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { NotificationServices } from "../../../core/services/NotificationServices";
import { updateIn } from "json-immut";

const Textarea = React.forwardRef((props: any, ref: any) => (
  <Input {...props} as="textarea" ref={ref} />
));

const SendNotification = ({
  openNotificationModal,
  setCheckedKeys,
  setOpenNotificationModal,
  isEditNotification = false,
  notificationObj = {},
  setIsEditNotification,
  setNotificationObj,
  userIds,
}: {
  openNotificationModal: boolean;
  setCheckedKeys: Function;
  setOpenNotificationModal: Function;
  isEditNotification: boolean;
  notificationObj: any;
  setIsEditNotification: any;
  setNotificationObj: any;
  userIds: number[];
}) => {
  const { t } = useTranslation();
  let editData = {
    title: notificationObj?.title,
    notification: notificationObj?.notification,
  };
  const [editNotificationData, setEditCaseValue] = useState<any>(editData);
  const [formError, setFormError] = useState<any>({});
  const [formData, setFormData] = useState({ title: "", notification: "" });
  const [loader, setLoader] = useState(false);

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }

  async function createNotification(payload: any) {
    try {
      setLoader(true);
      const res: any = await NotificationServices.createNotification(payload);
      if (res && res?.data?.status === httpStatusArr.ok) {
        setLoader(false);
        UtilityServices.showToaster({
          message: res?.data?.message,
        });
        setOpenNotificationModal(false);
        setCheckedKeys([]);
      }
    } catch (error: any) {
      setLoader(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function updateNotification(notifactionId: number, payload: any) {
    try {
      setLoader(true);
      const res: any = await NotificationServices.updateNotification(
        notifactionId,
        payload
      );
      if (res && res?.data?.status === httpStatusArr.ok) {
        setLoader(false);
        UtilityServices.showToaster({
          message: res?.data?.message,
        });
        setOpenNotificationModal(false);
      }
    } catch (error: any) {
      setLoader(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  const saveNotification = () => {
    let formFields: any = { ...formData };
    let payload = {
      user_ids: userIds.toString(),
      title: formFields["title"],
      notification: formFields["notification"],
    };

    if (isEditNotification) {
      updateNotification(+notificationObj.id, payload);
    } else {
      createNotification(payload);
    }
  };

  const formModel = Schema.Model({
    notification: StringType().isRequired(
      t("REQUIRED", {
        field: t("NOTIFICATION").toLowerCase(),
      })
    ),
  });

  return (
    <div className="modal-container">
      <Modal
        open={openNotificationModal}
        backdrop={true}
        onClose={(e: any) => {
          setNotificationObj({});
          setIsEditNotification(false);
          setOpenNotificationModal(false);
        }}
        size="sm"
      >
        {loader && (
          <Loader
            style={{ zIndex: 9999 }}
            size="lg"
            backdrop
            content={t("LOADING")}
            vertical
          />
        )}
        <Modal.Header>
          <h4>
            {isEditNotification ? t("EDIT") : t("SEND")} {t("NOTIFICATION")}{" "}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Content className="edit-cnt">
              <Form
                layout="horizontal"
                model={formModel}
                formDefaultValue={
                  Object.keys(editNotificationData).length
                    ? editNotificationData
                    : null
                }
                onSubmit={(e: any) => {
                  if (e) {
                    saveNotification();
                  }
                }}
                onChange={(data: any) => {
                  let form = { ...formData, ...data };
                  setFormData(form);
                }}
              >
                <Form.Group controlId="title"  className="ntfy-wd">
                  <Form.ControlLabel>{t("TITLE")}</Form.ControlLabel>
                  <Form.Control name="title" key="title" />
                </Form.Group>

                <Form.Group controlId="notification" className="ntfy-wd">
                  <Form.ControlLabel>{t("NOTIFICATION")}*</Form.ControlLabel>
                  <Form.Control
                    name="notification"
                    rows={5}
                    accepter={Textarea}
                  />
                </Form.Group>
                <div className="notification-tp-bx">
                  <Form.Group>
                    <Button appearance="primary" type="submit">
                      {isEditNotification ? t("UPDATE") : t("SEND")}{" "}
                      {t("NOTIFICATION")}
                    </Button>
                    <Button
                      style={{ marginLeft: "10px" }}
                      onClick={(e: any) => {
                        setOpenNotificationModal(false);
                      }}
                      appearance="primary"
                      color="red"
                      type="reset"
                    >
                      {t("CANCEL")}
                    </Button>
                  </Form.Group>
                </div>
              </Form>
            </Content>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SendNotification;
